export default {
  APP_ENV: 'production',
  API_ROOT: 'https://api.carson.live',
  FB_APP_ID: '1900403120230245',
  GOOGLE_CLIENT_ID:
    '110767077151-2longk9cjtmnhri8buupor2kifm7191f.apps.googleusercontent.com',
  BRANCH_KEY: 'key_live_dgDyJHYn1JypBT7VTQ17LnhfzwegkwV8',
  SENTRY_DNS: 'https://db8d304a70ae4a188b1bc5d9293412e4@sentry.io/1766902',
  BMX_URL: 'https://mediaserver.butterflymx.com:8443/',
  GA4ID: 'G-EXKRGV41QW',
  APPLE_CLIENT_ID: 'live.carson.admin',
  APPLE_REDIRECT_URI: 'https://admin.carson.live/login',
};
